import * as React from "react";
import { observer, inject } from "mobx-react";
import { NavLink } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import "./ApplicationTemplate.css";
import "react-toastify/dist/ReactToastify.css";
import horseImg from "src/assets/horse.png";
import MainNavigation from "./MainNavigation";
import MainUser from "./user";

interface Props {}

interface State {
    showSideBar: boolean;
}

@inject("sessionStore")
@observer
export class ApplicationTemplate extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            showSideBar: false
        };
    }

    toogleSideBar = (): void => {
        this.setState(prevState => ({
            showSideBar: !prevState.showSideBar
        }));
    };

    render() {
        return (
            <div className="content-wrapper">
                <div className="header-wrapper">
                    <header className={`header ${this.state.showSideBar ? `showSideBar` : ``} `}>
                        <div className={`logo ${this.state.showSideBar ? `showSideBar` : ``} `}>
                            <img
                                src={process.env.PUBLIC_URL + "/images/logo.png"}
                                alt="London Selected Yearling Sale"
                                className={`logo ${this.state.showSideBar ? `showSideBar` : ``} `}
                            />
                        </div>
                        <MainNavigation showSideBar={this.state.showSideBar} toogleSideBar={this.toogleSideBar} />
                        <MainUser showSideBar={this.state.showSideBar} />
                    </header>
                </div>
                <main className={`main ${this.state.showSideBar ? `showSideBar` : ``} `}>
                    <div className="decoration" />
                    <img src={horseImg} className="decoration-horse" />
                    <div className="content">{this.props.children}</div>
                </main>
                <ToastContainer
                    position="top-center"
                    autoClose={3500}
                    hideProgressBar={true}
                    newestOnTop={true}
                    closeOnClick={true}
                    rtl={false}
                    draggable={true}
                    pauseOnHover={true}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ApplicationTemplate.tsx